
import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten, getCurrentYear } from "../Helpers";
import { FaAndroid, FaApple, FaArrowCircleRight, FaChalkboardTeacher, FaGlobe } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import { MdCheck, MdLocationPin, MdSearch } from "react-icons/md";

export default function OneObjective({ content, icon }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	
	return (
		<div 
			className="text-center"
			style={{
				height: "230px",
				position: 'relative',
				overflow: "hidden",
				borderRadius: "20px",
				border: "1px solid var(--primaryColor)",
				marginBottom: "10px",
				padding: "10px"
			}}

		>
			{icon}

			<div
				className="text-center"
				style={{
					borderTop: "1px solid var(--primaryColor)",
					marginTop: "10px"
				}}
			>
				{content}
			</div>
		</div>
	)
	

	
}
